import * as React from 'react';
import Dropdown, { DROPDOWN_NO_VALUE } from '@common/containers/fields/Dropdown';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field, FieldError } from '../field';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';
import isNil from 'lodash/isNil';

import './select.styles.scss';

export type SelectSingleValue = string | number;
export type SelectValue = SelectSingleValue | Array<SelectSingleValue>;

export type SelectOption = {
  value: SelectSingleValue;
  label: string;
};

export type SelectProps = IInputComponent<SelectValue | undefined | null> & {
  clearable?: boolean;
  options: Array<SelectOption>;
  labelWidth?: number | string;
  label?: string;
  errors?: Array<FieldError>;
};

export const SELECT_EMPTY_VALUE = DROPDOWN_NO_VALUE;

export const Select: React.FC<SelectProps> = (props) => {
  const { errors, className, disabled, label, labelWidth, onChange, value, options, metadata, description, required, margin, clearable } = props;

  return (
    <Field 
      labelWidth={labelWidth} 
      label={label} 
      disabled={disabled}
      className={className}
      description={description}
      required={required}
      margin={margin}
      errors={errors}
      inputWidth={250}
    >
      <Dropdown
        {...getTestAttributes(MODULE_NAME, metadata.description, 'select')}
        isClearable={clearable && !isNil(value) && value !== ''}
        selectedValue={value}
        searchable={false}
        options={options}
        onValueChanged={onChange}
      />
    </Field>
  );
};